//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'leon-nopublic',
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 关闭登录框
    close () {
      this.$emit('close')
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonNoPublic/src/main.vue